import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const ABSTRACT =
  "https://static.prod-images.emergentagent.com/jobs/3b44b0d9-0951-43fe-b55c-9a10b0c5d696/images/1c0e1a0fe1f734e12e4e0b52bf9b0b8f45e577b4025ab8c5daed13c9795e488e.png";

export default function CTABanner() {
  return (
    <section data-testid="cta-banner" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <img src={ABSTRACT} alt="" className="w-full h-full object-cover opacity-90" />
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/85 to-background/30" />
      </div>

      <div className="max-page container-px">
        <Reveal>
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-8">
              <span className="overline">Let's Begin</span>
              <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-7xl leading-[1.02] text-foreground">
                Ready to unify your<br />
                <em className="not-italic text-primary/90">supply chain?</em>
              </h2>
              <p className="mt-8 max-w-xl text-base sm:text-lg text-muted-foreground leading-relaxed">
                Tell us what you need — a single SKU, a category rollout or a full
                project brief. We'll respond within one business day.
              </p>
            </div>

            <div className="lg:col-span-4 flex lg:justify-end">
              <Link
                to="/contact"
                data-testid="cta-banner-button"
                className="group inline-flex items-center gap-3 bg-primary text-primary-foreground px-9 py-5 rounded-full text-sm tracking-wide hover:bg-foreground transition-all duration-500"
              >
                Start a Conversation
                <ArrowRight className="w-4 h-4 transition-transform duration-500 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
